import { Autocomplete, Divider, Icon, InlineError, InlineStack, Tag, Text, Thumbnail } from '@shopify/polaris';
import { useCallback, useEffect, useState } from 'react';
import { SearchIcon, PlusCircleIcon } from '@shopify/polaris-icons';
import UserGroupModalAddAndEdit from './user_group.edit.modal';
import { TypedUser_group, useGetUser_groups } from 'queries/user_group.query';
import __helpers from 'helpers/index';

export default function QuickSearchUserGroup({
  onClose,
  errorMessage = '',
  current_user_group_id,
  displaySelected = true,
}: {
  onClose: (val: string[]) => void;
  errorMessage?: string;
  current_user_group_id: string[];
  displaySelected?: boolean;
}) {
  /**  Lưu cả array lại để tẹo hiển thị  */

  const { isLoading: searching, data: entities } = useGetUser_groups({
    limit: 50,
    user_group_status: 1,
    sort: 'createdAt:desc',
  });

  /**
   *  list
   */

  const [postCategoryList, setPostCategoryList] = useState(null);

  useEffect(() => {
    if (entities) {
      let { body, totalItems } = entities;
      setPostCategoryList(body);
    }
  }, [entities]);

  /**
   * Assign cho ai đóa
   */
  const [categorySelected, setCategorySelected] = useState<string[] | null>([]);
  const [userQuickSearchText, setUserQuickSearchText] = useState<string>('');
  const [userGroupListForQuickOption, setuserGroupListForQuickOption] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if (!current_user_group_id) return;
    setCategorySelected(current_user_group_id);
  }, [current_user_group_id]);

  const callmebackCallback = useCallback((selected) => {
    onClose(selected);
  }, []);

  useEffect(() => {
    let innerUser = [];
    if (postCategoryList)
      for (let userGroupData of postCategoryList) {
        innerUser.push({
          value: userGroupData.user_group_id,
          label: userGroupData.user_group_name,
        });
      }

    setuserGroupListForQuickOption(innerUser);
  }, [postCategoryList]);

  const updateText = useCallback(
    (value: string) => {
      setUserQuickSearchText(value);

      if (value === '') {
        setuserGroupListForQuickOption(userGroupListForQuickOption);
        return;
      }

      const filterRegex = new RegExp(value, 'i');
      const resultOptions = userGroupListForQuickOption.filter((option) => option.label.match(filterRegex));
      setuserGroupListForQuickOption(resultOptions);
    },
    [userGroupListForQuickOption]
  );

  const updateSelection = useCallback(
    (selected: string[]) => {
      const selectedValue = selected.map((selectedItem) => {
        const matchedOption = userGroupListForQuickOption.find((option) => {
          return option.value.match(selectedItem);
        });
        return matchedOption && matchedOption.label;
      });
      setCategorySelected(selected);
      //   setUserQuickSearchText(selectedValue[0] || '');
      callmebackCallback(selected);
    },
    [userGroupListForQuickOption]
  );

  /** ABC DEF GHI */

  const removeTag = useCallback(
    (tag: string) => () => {
      const options = [...categorySelected];
      options.splice(options.indexOf(tag), 1);
      setCategorySelected(options);
      callmebackCallback(options);
    },
    [categorySelected]
  );

  const [showQuickCreate, setShowQuickCreate] = useState(false);

  const verticalContentMarkup =
    categorySelected.length > 0 ? (
      <InlineStack align="start" blockAlign="center" gap="200">
        {categorySelected.map((option) => {
          if (!option) return;
          let l = userGroupListForQuickOption.find((el) => el.value === String(option))?.label;
          if (!l) return;
          return (
            <Tag key={`option${option}`} onRemove={removeTag(option)}>
              <InlineStack gap="200" align="start" blockAlign="center">
                <Text as="span">{l}</Text>
              </InlineStack>
            </Tag>
          );
        })}
      </InlineStack>
    ) : (
      <Text as="p" tone="subdued" variant="bodySm">
        Chưa có một nhóm nào ...
      </Text>
    );

  const textFieldSelectUser = (
    <>
      <Autocomplete.TextField
        error={errorMessage ? true : false}
        onChange={updateText}
        label="Tìm một nhóm"
        value={userQuickSearchText}
        prefix={<Icon source={SearchIcon} tone="base" />}
        placeholder="Tìm kiếm"
        autoComplete="off"
        id="TextFieldSelectUserGroup"
      />
      <div style={{ marginTop: '4px' }}>
        <InlineError message={errorMessage} fieldID="TextFieldSelectUserGroup" />
      </div>
    </>
  );

  return (
    <>
      <UserGroupModalAddAndEdit
        show={showQuickCreate}
        onClose={(user_group_id: bigint) => {
          setShowQuickCreate(false);
          if (user_group_id) setCategorySelected((old) => [...old, ...[String(user_group_id)]]);
        }}
      />

      {displaySelected === true && (
        <>
          {verticalContentMarkup}
          <br />
          <Divider />
          <br />
        </>
      )}

      <Autocomplete
        actionBefore={{
          accessibilityLabel: 'Tạo nhóm mới',
          content: 'Tạo một nhóm mới',
          ellipsis: true,
          helpText: 'Tạo nhóm mới và chỉnh sửa sau',
          icon: PlusCircleIcon,
          onAction: () => {
            setShowQuickCreate(!showQuickCreate);
          },
        }}
        allowMultiple
        options={userGroupListForQuickOption}
        selected={categorySelected}
        onSelect={updateSelection}
        textField={textFieldSelectUser}
        loading={searching}
      />
    </>
  );
}

